// extracted by mini-css-extract-plugin
export default {"root":"_5Wk5T","left":"_1dx34","left-side-item-wrapper":"_2luek","leftSideItemWrapper":"_2luek","right":"_3af4N","right-side-item-wrapper":"_1sQ_d","rightSideItemWrapper":"_1sQ_d"};